import React from 'react';
import DamTransferList from '../../components/DamTransfers/DamTransferList';

const DAMTransfers: React.FC = () => {

    return (<div>
        <DamTransferList />
    </div>)
};

export default DAMTransfers;